import { useQuery } from "@tanstack/react-query";
import { getNotificariRecalcul } from "@/api/endpoints/notificari";
import { queryKeys } from "@/lib/queryClient";

export function useGetNotificariRecalcul(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.notificari.recalcul(),
    queryFn: getNotificariRecalcul,
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
